(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationCampaignController', CommunicationCampaignController);

    CommunicationCampaignController.$inject = ['$state', '$stateParams', '$filter', 'CommunicationCampaign', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CommunicationCampaignController($state, $stateParams, $filter, CommunicationCampaign, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.search = search;
        vm.clear = clear;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.searchTitle = $stateParams.title;
        vm.channel = $stateParams.channel;
        vm.cancelled = $stateParams.cancelled;
        vm.sendingDone = $stateParams.sendingDone;
        vm.date = {
            startDate: $stateParams.desiredSendDateFrom ? new Date($stateParams.desiredSendDateFrom) : null,
            endDate: $stateParams.desiredSendDateTo ? new Date($stateParams.desiredSendDateTo) : null
        };
        vm.channels = [];

        loadChannels();
        loadAll();

        function loadAll() {
            CommunicationCampaign.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                title: vm.searchTitle,
                channel: vm.channel,
                cancelled: vm.cancelled,
                sendingDone: vm.sendingDone,
                desiredSendDateFrom: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                desiredSendDateTo: $filter('date')(vm.date.endDate, 'yyyy-MM-dd')
            }, onSuccess, onError);
        }

        function loadChannels() {
            CommunicationCampaign.getChannel().$promise.then(function(result) {
                vm.channels = result || [];
            }, function() {
                vm.channels = [];
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.communicationCampaigns = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error && error.data && error.data.message ? error.data.message : 'Erreur lors du chargement des campagnes.');
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function search() {
            vm.page = 1;
            vm.transition();
        }

        function clear() {
            vm.page = 1;
            vm.predicate = 'createdDate';
            vm.reverse = false;
            vm.searchTitle = null;
            vm.channel = null;
            vm.cancelled = null;
            vm.sendingDone = null;
            vm.date.startDate = null;
            vm.date.endDate = null;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                title: vm.searchTitle,
                channel: vm.channel,
                cancelled: vm.cancelled,
                sendingDone: vm.sendingDone,
                desiredSendDateFrom: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                desiredSendDateTo: $filter('date')(vm.date.endDate, 'yyyy-MM-dd')
            });
        }
    }
})();
